import {ActionUrl, CREATE_GROUP_BTN_CLASS_NAME, DEFAULT_TEMPLATE_CLASS_NAME} from "../constants";
import {getEmptyGroupTemplate, getNewGroupTemplate} from "../template";
import {renderElement} from "../../utils/common";
import {Api, Method} from "../../api/api";
import {showToast} from "../../toast";

/**
 * Функционал отвечает за создание группы меток
 */
class CreateGroup {
  #parent;
  #formElement;
  #removeBtnElement;
  #nameInputElement;
  #emptyGroupElement;

  #createBtnElement = document.querySelector(`.${CREATE_GROUP_BTN_CLASS_NAME}`);
  #api = new Api();

  constructor(parent) {
    this.#parent = parent;

    this.onCreateBtnElementClick = this.onCreateBtnElementClick.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onRemoveBtnClick = this.onRemoveBtnClick.bind(this);

    if (this.#createBtnElement) {
      this.#createBtnElement.addEventListener(`click`, this.onCreateBtnElementClick);
    }
  }

  /**
   * Удаление первоначального шаблона
   */
  #removeDefaultTemplate() {
    if (this.#parent.querySelector(`.${DEFAULT_TEMPLATE_CLASS_NAME}`)) {
      this.#parent.querySelector(`.${DEFAULT_TEMPLATE_CLASS_NAME}`).remove();
    }
  }

  /**
   * Рендер пустого шаблона с группой меток
   *
   */
  #renderEmptyTemplate() {
    this.#emptyGroupElement = renderElement(this.#parent, getEmptyGroupTemplate());
    this.#formElement = this.#emptyGroupElement.querySelector(`form`);
    this.#removeBtnElement = this.#emptyGroupElement.querySelector(`.js-remove`);
    this.#nameInputElement = this.#formElement.querySelector(`input`);

    this.#removeBtnElement.addEventListener(`click`, this.onRemoveBtnClick, {once: true});
    this.#formElement.addEventListener(`submit`, this.onFormSubmit);
  }

  /**
   * Рендер нового шаблона с группой меток
   *
   * @param name {string} - название группы меток
   * @param id {string} - идентификатор группы меток
   */
  #renderNewTemplate(name, id) {
    renderElement(this.#parent, getNewGroupTemplate(name, id));
  }

  /**
   * Удаление пустого шаблона
   */
  #removeEmptyTemplate() {
    this.#emptyGroupElement.remove();

    this.#emptyGroupElement = null;
  }

  /**
   *
   * @param name {string} - Название группы меток
   * @returns {Promise<void>}
   */
  async #postData(name) {
    const {code, answer} = await this.#api.customQuery(ActionUrl.CREATE_GROUP_URL, {method: Method.POST, query: JSON.stringify({name})});

    if (code === 200) {
      this.#removeEmptyTemplate();
      this.#renderNewTemplate(name, answer.data.id);
    } else {
      showToast(answer.data.text);
    }
  }

  /**
   * Слушатель нажатия на кнопку удаления пустого шаблона
   *
   */
  onRemoveBtnClick() {
    this.#removeEmptyTemplate();
  }

  /**
   * Слушатель на отправку формы
   *
   * @param event
   */
  onFormSubmit(event) {
    event.preventDefault();

    const name = this.#nameInputElement.value.trim();

    if (name.length > 0) {
      void this.#postData(name);
    } else {
      this.#nameInputElement.classList.add(`tags__name-input--error`);
    }
  }

  /**
   * Слушатель слика на кнопку создания группы меток
   */
  onCreateBtnElementClick() {
    if (!this.#emptyGroupElement) {
      this.#removeDefaultTemplate();
      this.#renderEmptyTemplate();
    }
  }
}

export {CreateGroup};
